"use strict";
/**
 * mock data for payment method
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockDataAllOptions = exports.mockData = void 0;
exports.mockData = [
    {
        name: 'CARD',
        type: 'CHECKOUT'
    },
    {
        name: 'CASH',
        type: 'PAY_AT_BRANCH'
    }
];
exports.mockDataAllOptions = [
    { name: 'CARD', type: 'CHECKOUT' },
    { name: 'APPLE_PAY', type: 'CHECKOUT' },
    { name: 'CASH', type: 'PAY_AT_BRANCH' }
];
